import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuthStore } from '../hooks/useAuth'

export default function Login() {
  const [email, setEmail]     = useState('')
  const [password, setPassword] = useState('')
  const [error, setError]     = useState('')
  const { login, isLoading }  = useAuthStore()
  const navigate = useNavigate()

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError('')
    try {
      await login(email, password)
      navigate('/dashboard')
    } catch (err: any) {
      setError(err.message)
    }
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ width: '100%', maxWidth: 380 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <Link to="/" style={{ fontFamily: 'Syne', fontWeight: 800, fontSize: '1.4rem', color: 'var(--bill)', textDecoration: 'none' }}>
            Polywally<span style={{ fontFamily: 'Syne Mono', fontSize: '0.38rem', color: 'var(--cash)', verticalAlign: 'super', marginLeft: 2 }}>™</span>
          </Link>
          <div style={{ fontFamily: 'Syne Mono', fontSize: '0.6rem', letterSpacing: '0.2em', color: 'var(--muted)', marginTop: 4 }}>SIGN IN</div>
        </div>

        <div style={{ background: 'var(--card)', border: '1px solid var(--edge)', borderRadius: 4, padding: 28 }}>
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {error && <div style={{ fontFamily: 'Syne Mono', fontSize: '0.68rem', color: 'var(--red)', background: 'rgba(224,92,92,.07)', border: '1px solid rgba(224,92,92,.2)', borderRadius: 2, padding: '8px 10px' }}>{error}</div>}
            <input type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required style={{ background: 'var(--paper)', border: '1px solid var(--edge)', borderRadius: 2, padding: '10px 13px', color: 'var(--text)', fontFamily: 'Syne Mono', fontSize: '0.78rem', outline: 'none' }} />
            <input type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} required style={{ background: 'var(--paper)', border: '1px solid var(--edge)', borderRadius: 2, padding: '10px 13px', color: 'var(--text)', fontFamily: 'Syne Mono', fontSize: '0.78rem', outline: 'none' }} />
            <button type="submit" disabled={isLoading} style={{ padding: '10px', background: 'var(--cash)', color: 'var(--ink)', border: 'none', borderRadius: 2, fontFamily: 'Syne', fontWeight: 800, fontSize: '0.8rem', cursor: 'pointer', opacity: isLoading ? .5 : 1 }}>
              {isLoading ? 'Signing in...' : 'Sign In →'}
            </button>
          </form>
          <div style={{ marginTop: 18, display: 'flex', justifyContent: 'space-between', fontFamily: 'Syne Mono', fontSize: '0.65rem', color: 'var(--muted)' }}>
            <Link to="/forgot-password" style={{ color: 'var(--muted)', textDecoration: 'none' }}>Forgot password?</Link>
            <span>No account? <Link to="/signup" style={{ color: 'var(--cash)', textDecoration: 'none' }}>Sign up free</Link></span>
          </div>
        </div>
      </div>
    </div>
  )
}
